import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import Chart from 'react-apexcharts'

import { Link } from "react-router-dom";
import { dateDataTimeFormatter,dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";

const margin = {top: 20, right: 20, bottom: 30, left: 40};
 

class CertReqPlot extends React.Component {
    
    constructor(props) {
        super(props);
       
        this.state = {
          options: {
            chart: {
              fontFamily: 'shabnam',
              id: 'apexchart-example'
            },
            yaxis: {
              show: true,
              labels: {
                formatter: (value) => { return value }
              }
            },
            dataLabels :{
                formatter: function (val, opts) {
                return val
              }
            },
            xaxis: {
              categories: []
            },
            subtitle: {
              text: '',
              align: 'center',
              margin: 10,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize:  '14px',
                color:  '#9699a2'
              },
            }
          },
          series: [],
         
        }
        

       
      }

    componentWillReceiveProps(newProps)
    {
        const {categories,data,title,formatter}=newProps;

        if(formatter)
        {
          const {options}=this.state;
          options.yaxis.labels.formatter=formatter;
          options.dataLabels.formatter=formatter;

          this.setState({
            options:options
          })

        }


        if(categories)
        {
            
            const {options}=this.state;
            
            options.xaxis.categories=categories;

            this.setState({
              options:options
            })

        }
        if(title)
        {
          const {options}=this.state;
          options.subtitle.text=title;
          this.setState({
            options:options
          })

        }
        if(data)
        {
        
          const {series}=this.state;
          series.push({name:'data',data:data});
          this.setState({
            series:series
          })
        }

    }  

    componentDidMount()
    {
      // window.onresize = () => {
      //   this.setState({width: this.refs.root.offsetWidth}); 
      // };
    } 
  
    render() { 
      const {data}=this.props;
      console.log('STATE',this.state)
        return ( 
          <div ref='root'>
            <div style={{width: '100%'}}> 
            {data &&
                <Chart options={this.state.options} series={this.state.series} type="bar" width={550} height={320} />
            }
            </div>
          </div>
        
        );
    }
}

 
export default CertReqPlot;